// JoinProgressBadge.js
'use strict';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import withRouter from '../component/WithRouter.jsx';

import addModal from '../action/addModal.js';

import getOperationData from '../selector/getOperationData.js';
import getJoinProgress from '../selector/getJoinProgress.js';

import JoinProgressBadge from '../component/JoinProgressBadge.jsx';

const mapStateToProps = (state, { location }) => {
  return {
    progress: getJoinProgress(state),
    kycFailedreasons: getOperationData(state, ['join', 'kyc'], 'failedReasons'),
    location,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: ({ pathname }) => dispatch(push(pathname)),
    addModal: ({ id }) =>
      dispatch(
        addModal({
          id,
          transitionStatus: 'opening',
        })
      ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JoinProgressBadge)
);
